import { type TFunction } from 'i18next';

export const validateName = (value: string, t: TFunction) => {
  const trimmedValue = value.trim();

  if (!trimmedValue.length) {
    return t('Name is required.');
  }

  if (trimmedValue.length > 255) {
    return t('Name must be less than 255 characters.');
  }

  return true;
};

export const isUrlValid = (value: string): boolean => {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};
